var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"lck-paragraph"},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }